import React, { Component, PropTypes } from 'react';

const PreviewIcon = ({ fontData, icon, className }) => {
    return (
        <div className={className}>
            <a
                className="active-hover"
                href="#"
                style={{
                    color: fontData
                }}
            >
                {' '}
                <span className={icon} />
            </a>
        </div>
    );
};

PreviewIcon.propTypes = {
    fontData: PropTypes.any,
    text: PropTypes.string,
    icon: PropTypes.string,
    className: PropTypes.string
};

export default PreviewIcon;



// WEBPACK FOOTER //
// ./src/components/pages/theme/carousel/PreviewIcon.js